import { axios } from 'libs';

import { removeSolicitacaoJson } from './ProcessoPayload';

const resource = '/processos/referenciados';

export const getReferenciadosById = id => {
  return axios.get(`${resource}${id}`);
};

export const getReferenciadosAndPrincipalById = id => {
  return axios.get(`${resource}-and-principal${id}`);
};

export const save = (processoReferencia, processoReferenciado) => {
  return axios.post(resource, {
    processoReferencia: removeSolicitacaoJson(processoReferencia),
    processoReferenciado: removeSolicitacaoJson(processoReferenciado)
  });
};

export const remove = processoReferenciado => {
  return axios.delete(resource, {
    data: { processoReferenciado: removeSolicitacaoJson(processoReferenciado) }
  });
};

export const cloneArquivos = id => {
  return axios.post(`${resource}/clone-arquivos${id}`);
};
